import { oase_config } from '../../environments/environment';
import { Session } from './session.model';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { Fragebogen } from '../protected/fragebogen/fragebogen.model';
import { Frage } from '../protected/fragebogen/frage.model';
import { Antwort } from '../protected/fragebogen/antwort.model';

const PATH_FILE = 'app/shared/session.service.ts';

@Injectable()
export class SessionService {
  constructor(
    private _logger: LoggerService) { }

  private storeSession(session: Session) {
    return localStorage.setItem(oase_config.sessiondata.name, JSON.stringify(session));
  }

/*
  storeNewToken(response: Response) {
    if(response !== null && response.headers !== null && response.headers.get(oase_config.sessiondata.name) !== null)
      this.storeJwToken(response.headers.get(oase_config.sessiondata.name));
  }
*/
  private getSession(): Session {
    let sessiondata: string = localStorage.getItem(oase_config.sessiondata.name);
    if(sessiondata == null)
      return new Session();
    return JSON.parse(sessiondata);
  }

  private sessionExists() {
    return this.getSession() !== null;
  }

  removeSessionStore() {
    return localStorage.removeItem(oase_config.sessiondata.name);
  }

  logSessionInfos(prefix: string) {
    this._logger.log(prefix + ' session: ', this.getSession());
  }

  setFragebogen(fragebogen: Fragebogen) {
    let sessiondata: Session = new Session();
    sessiondata.pfad.fragebogen.obj = fragebogen;
    this.storeSession(sessiondata);
  }
  getFragebogen(): Fragebogen {


    let sessiondata: Session = this.getSession();
    this._logger.log('getFragebogen() session: ', sessiondata);

    if(sessiondata == null ||
       sessiondata.pfad == null ||
       sessiondata.pfad.fragebogen == null ||
       sessiondata.pfad.fragebogen.obj == null)
      return null;
    return sessiondata.pfad.fragebogen.obj;
  }
  setFrage(frage: Frage) {
    let sessiondata: Session = this.getSession();
    sessiondata.pfad.fragebogen.kinder.frage.obj = frage;
    this.storeSession(sessiondata);
  }
  getFrage(): Frage {
    let sessiondata: Session = this.getSession();
    if(sessiondata == null ||
       sessiondata.pfad == null ||
       sessiondata.pfad.fragebogen == null ||
       sessiondata.pfad.fragebogen.kinder == null ||
       sessiondata.pfad.fragebogen.kinder.frage == null ||
       sessiondata.pfad.fragebogen.kinder.frage.obj == null)
      return null;
    return sessiondata.pfad.fragebogen.kinder.frage.obj;
  }
  setAntwort(antwort: Antwort) {
    let sessiondata: Session = this.getSession();
    sessiondata.pfad.fragebogen.kinder.frage.kinder.antwort.obj = antwort;
    this.storeSession(sessiondata);
  }
  getAntwort(): Antwort {
    let sessiondata: Session = this.getSession();
    if(sessiondata == null ||
       sessiondata.pfad == null ||
       sessiondata.pfad.fragebogen == null ||
       sessiondata.pfad.fragebogen.kinder == null ||
       sessiondata.pfad.fragebogen.kinder.frage == null ||
       sessiondata.pfad.fragebogen.kinder.frage.kinder == null ||
       sessiondata.pfad.fragebogen.kinder.frage.kinder.antwort.obj == null)
      return null;
    return sessiondata.pfad.fragebogen.kinder.frage.kinder.antwort.obj;
  }

  isCopydialogOpen() {
    if (localStorage.getItem(oase_config.iscopydialogopend) == null) { localStorage.setItem(oase_config.iscopydialogopend, 'false'); }
    return localStorage.getItem(oase_config.iscopydialogopend) === 'true';
  }

  toggleCopydialogOpen(): boolean {
    localStorage.setItem(oase_config.iscopydialogopend, !this.isCopydialogOpen() ? 'true' : 'false');
    return this.isCopydialogOpen();
  }

  isAddingToCopyAllowed(): boolean {
    if (localStorage.getItem(oase_config.isaddingtocopyallowed) == null) { this.disableAddingToCopyAllowed(); }
    if (this.isCopydialogOpen()) { return localStorage.getItem(oase_config.isaddingtocopyallowed) === 'true'; }
    return false;
  }

  enableAddingToCopyAllowed(): void {
    localStorage.setItem(oase_config.isaddingtocopyallowed, 'true');
  }

  disableAddingToCopyAllowed(): void {
    localStorage.setItem(oase_config.isaddingtocopyallowed, 'false');
  }

  removeCopyInformations(): void {
    localStorage.removeItem(oase_config.iscopydialogopend);
    localStorage.removeItem(oase_config.isaddingtocopyallowed);
  }

}
